export const readFromLocalStorage = (key: string) => {
  const rawRecord = localStorage.getItem(key)
  if (!rawRecord) return null

  const record = JSON.parse(rawRecord)
  const now = new Date()

  if (record.exp && now.getTime() > record.exp) {
    localStorage.removeItem(key)

    return null
  }

  return record.value
}

export const writeToLocalStorage = (key: string, value: any, ttlInSeconds: number = 0) => {
  const now = new Date()
  const record = {
    value: value,
    exp: ttlInSeconds ? now.getTime() + (ttlInSeconds * 1000) : false
  }

  localStorage.setItem(key, JSON.stringify(record))
}

// Session storage utilities (no TTL needed since session storage clears on tab close)
export const readFromSessionStorage = (key: string) => {
  const rawRecord = sessionStorage.getItem(key)
  if (!rawRecord) return null

  const record = JSON.parse(rawRecord)
  return record.value
}

export const writeToSessionStorage = (key: string, value: any) => {
  const record = {
    value: value
  }

  sessionStorage.setItem(key, JSON.stringify(record))
}
